// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PosList_wrapper__Ts6SD","pos-wrapper":"PosList_pos-wrapper__wysjQ","wrapper-pagination":"PosList_wrapper-pagination__hJ6bd"};